import React, { useEffect, useState, useRef } from "react";
import api, { formatApiError, API } from "../../lib/api";
import { toast } from "sonner";
import { UploadSimple, File, Trash, DownloadSimple } from "@phosphor-icons/react";

export default function DocumentsTab({ userId, isAdmin }) {
  const [docs, setDocs] = useState([]);
  const [uploading, setUploading] = useState(false);
  const [title, setTitle] = useState("");
  const fileRef = useRef(null);

  const load = async () => {
    try {
      const { data } = await api.get(`/users/${userId}/documents`);
      setDocs(data);
    } catch (err) {
      toast.error(formatApiError(err));
    }
  };
  useEffect(() => { load(); /* eslint-disable-next-line */ }, [userId]);

  const handleUpload = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    setUploading(true);
    try {
      const fd = new FormData();
      fd.append("file", file);
      fd.append("title", title || file.name);
      await api.post(`/users/${userId}/documents`, fd, { headers: { "Content-Type": "multipart/form-data" } });
      toast.success("Documento subido");
      setTitle("");
      if (fileRef.current) fileRef.current.value = "";
      load();
    } catch (err) {
      toast.error(formatApiError(err));
    } finally {
      setUploading(false);
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm("¿Eliminar documento?")) return;
    try {
      await api.delete(`/documents/${id}`);
      toast.success("Eliminado");
      load();
    } catch (err) {
      toast.error(formatApiError(err));
    }
  };

  const formatSize = (b) => {
    if (b < 1024) return `${b} B`;
    if (b < 1024 * 1024) return `${(b / 1024).toFixed(1)} KB`;
    return `${(b / 1024 / 1024).toFixed(1)} MB`;
  };

  return (
    <div>
      {isAdmin && (
        <div className="card-base p-6 mb-6 border-dashed" data-testid="document-upload">
          <h3 className="font-display font-bold uppercase text-lg mb-4">Subir Documento</h3>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-3">
            <input className="input-base md:col-span-2" placeholder="Título (opcional)" value={title} onChange={(e) => setTitle(e.target.value)} data-testid="doc-title" />
            <label className="btn-primary cursor-pointer flex items-center justify-center gap-2">
              <UploadSimple size={16} weight="bold" />
              {uploading ? "Subiendo..." : "Seleccionar archivo"}
              <input ref={fileRef} type="file" className="hidden" onChange={handleUpload} data-testid="doc-file-input" />
            </label>
          </div>
          <p className="text-xs text-muted mt-3">Cualquier tipo de archivo: PDF, Word, Excel, imágenes, videos, etc.</p>
        </div>
      )}

      {docs.length === 0 ? (
        <div className="card-base p-12 text-center text-muted">No hay documentos cargados</div>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4" data-testid="documents-list">
          {docs.map((d) => (
            <div key={d.document_id} className="card-base p-5 hover:border-[#FF3B30] transition-colors">
              <div className="flex items-start gap-3 mb-3">
                <File size={28} weight="duotone" className="text-accent-blue flex-shrink-0" />
                <div className="flex-1 min-w-0">
                  <div className="font-display font-bold uppercase text-sm truncate">{d.title}</div>
                  <div className="text-xs text-muted truncate">{d.original_name}</div>
                </div>
              </div>
              <div className="text-xs text-muted mb-3">
                {formatSize(d.size || 0)} · {d.created_at?.slice(0, 10)}
              </div>
              <div className="flex gap-2">
                <a href={`${API}/files/${d.file_id}`} target="_blank" rel="noopener noreferrer" className="btn-secondary !py-2 !px-3 flex items-center gap-1 flex-1 justify-center" data-testid={`download-doc-${d.document_id}`}>
                  <DownloadSimple size={14} weight="bold" /> Abrir
                </a>
                {isAdmin && (
                  <button onClick={() => handleDelete(d.document_id)} className="btn-secondary !py-2 !px-3 hover:!border-[#FF3B30]" data-testid={`delete-doc-${d.document_id}`}>
                    <Trash size={14} weight="bold" />
                  </button>
                )}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
